import { render, staticRenderFns } from "./WorkInfo.vue?vue&type=template&id=0ed20ce4&scoped=true"
import script from "./WorkInfo.vue?vue&type=script&lang=js"
export * from "./WorkInfo.vue?vue&type=script&lang=js"
import style0 from "./WorkInfo.vue?vue&type=style&index=0&id=0ed20ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed20ce4",
  null
  
)

export default component.exports